export const states = {
	worksData: [],
	calendarEvents: []
}